import { useGetConversationInfo } from 'hooks/business/conversation';
import { message } from 'antd';
import { updateConversation, updateConversationV2 } from 'services/api/conversation.convList';
import { useTranslate } from '@tolgee/react';

export type UpdateConversationType = 'asterisk' | 'read' | 'delete';

const useConversationOps = () => {
  const getConversationInfo = useGetConversationInfo();
  const { t } = useTranslate();

  const modifyConversation = async (
    conversationId: string,
    upVal: {
      asterisk?: ApiConversation.UpdateConversationParam['asterisk'];
      read?: ApiConversation.UpdateConversationParam['read'];
      delete?: ApiConversation.UpdateConversationParam['delete'];
    },
    cb?: Function,
  ) => {
    const convInfo = await getConversationInfo(conversationId);
    const d: ApiConversation.UpdateConversationParam = {
      talkId: [convInfo.talkId],
      ...upVal,
    };

    return updateConversation(d)
      .then(() => cb && cb())
      .catch(() => {
        message.error(t('api.updateConversationErr'));
      });
  };

  const modifyConversationV2 = (
    reqParam: ApiConversation.UpdateConversationV2Param,
    cb?: Function,
  ) => {
    return updateConversationV2(reqParam)
      .then(() => cb && cb())
      .catch(() => {
        message.error(t('translation.操作失败，请稍后再试'));
      });
  };

  return {
    modifyConversation,
    modifyConversationV2,
  };
};

export default useConversationOps;
